import { Component, Input } from '@angular/core';
import { AngularModule } from '../../../../../../modules/angular.module';
import { StrideAssessmentItem } from '@mira-avant/mtlibs';

@Component({
	selector: 'app-stride-assessment',
	standalone: true,
	imports: [AngularModule],
	templateUrl: './stride-assessment.component.html',
	styleUrl: './stride-assessment.component.scss',
})
export class StrideAssessmentComponent {
	@Input('assessments') public assessments: StrideAssessmentItem[] = [];
}
